export enum StoreControls {
  store = 'store',
  city = 'city',
}
